// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".getstart-only-form-wrapper ::v-deep .getstart-form-sub{overflow-x:hidden}[dir] .trans-bg .lead,[dir] .trans-bg .registration-form{background-color:transparent}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
